import { useReducer as r } from "react";
const n = () => (e, s) => {
  switch (s.type) {
    case "close":
      return {
        ...e,
        open: !1
      };
    case "open":
      return {
        ...e,
        open: !0
      };
    case "loading":
      return {
        ...e,
        isBackEnable: !1,
        isNextEnable: !1,
        step: s.step,
        progress: !0
      };
    case "next":
      return {
        ...e,
        progress: !1,
        step: s.step
      };
    case "toggle-buttons":
      return {
        ...e,
        isBackEnable: s.isBackEnable,
        isNextEnable: s.isNextEnable
      };
  }
};
function p() {
  const [e, s] = r(
    n(),
    {
      step: 0,
      isNextEnable: !1,
      progress: !1,
      open: !1
    }
  );
  return { state: e, dispatch: s };
}
export {
  p as useStepperReducer
};
//# sourceMappingURL=useStepperReducer.js.map
